/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import Menu from '../../../../components/Peyks/Menu'
import { notify } from '../../../../components/Toast'

import { get } from '../../../../services/http'

import ReactPaginate from 'react-paginate'

import foodIcon from '../../../../assets/svg/orderIcon.svg'
import Table from '../../../../components/Peyks/peykOrder'

import { useNavigate } from 'react-router-dom'

export default function index() {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate()

  const [orders, setOrders] = useState('')
  const [ordersCount, setOrdersCount] = useState()
  const [peykName, setPeykName] = useState('')
  const [totalPage, setTotalPage] = useState()
  const [name, setName] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/peyks/orders?token=${token}`)
      .then(response => {
        console.log(response)
        setOrders(response.data.data.docs)
        setTotalPage(response.data.pages)
        setOrdersCount(response.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])
  
  const handlePageClick = (event) => {
    get(`/api/admin/peyks/orders?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setOrders(response.data.data.docs)
      setTotalPage(response.data.pages)
      setOrdersCount(response.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }
  
  const searchBtnHandler = () => {
    get(`/api/admin/peyks/${name}?token=${token}`)
    .then(response => {
      console.log(response)
      setPeykName(`${response.data.data.name} - 0${response.data.data.phoneNumber}`)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }
  
  const getAllDataHandler = () => {
    get(`/api/admin/peyks/orders?token=${token}`)
      .then(response => {
        setOrders(response.data.data.docs)
        setTotalPage(response.data.pages)
        setOrdersCount(response.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  document.title = 'سفارشات'

  return (
    <main id='panel'>
      <Menu page={'orders'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                سفارشات
              </div>
            </div>

            <div className="left">
              <button onClick={getAllDataHandler}>دریافت کل اطلاعات</button>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">آیدی پیک : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler}>جستجو</button>
              <div style={{ marginRight: '10px' }}>
                {peykName}
              </div>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل سفارشات
              </div>
              <div className="left">
                {ordersCount}
              </div>
            </div>

            <Table data={orders} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
